<app-onboarding-crud *ngIf="isShowCRUD" [currentPassword]="currentPassword" [loginId]="loginId"></app-onboarding-crud>
<app-onboarding-email-password-reset *ngIf="isShowPasswordEmailReset"></app-onboarding-email-password-reset>
<app-onboarding-password-reset *ngIf="isShowPasswordReset" [passwordKey]="passwordKey" [loginId]="loginId"></app-onboarding-password-reset>
